import { azmoonRoutes } from "./azmoon-routes";

export default (router: any) => {
  azmoonRoutes.forEach((route: any) => {
    router.addRoute(route);
  });
};
